import {getChildrenClassForNestedItems} from "../../../default/global/js/nav";
import {initActionClicks, initFormSubmitChanges, initFormSubmitClicks} from "../../../default/global/js/actionClick";
import {focusInputGroups} from "../../../default/global/js/checkInputGroups";
import hoverintent from "../../../default/global/js/hoverintent";
import {initSlideshows} from "../../../default/global/js/slideshow";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {stickyBox} from "../../../default/global/js/stickyBox.js";
import {buildMobileMenu, hideMobileMenu, showMobileMenu} from "../../../default/global/js/mobilemenu";
import {
    excludeModal,
    triggerConfirmModalLink,
    triggerModal,
    triggerOpenLinkInModal
} from "../../../default/global/js/modal";
import {initToggleSlide} from "../../../default/global/js/toggle";
import {setSrcVideos} from "../../../default/global/js/video";
import {initScrollbars} from "../../../default/global/js/scrollbar";
import {isTouchDevice} from "../../../default/global/js/touchDevice";
import {initCustomSelects} from "../../../default/global/js/customSelect";
import {initJumpmarks} from "../../../default/global/js/jumpmark";
import {trimInputValues} from "../../../default/global/js/formValidator";
import {lottieLoader} from "../../../default/global/js/lottieLoader";
import {initSlidecontents} from "../../../default/global/js/slidecontent";
import {addTableWrapper} from "../../../default/global/js/tableWrapper";
import {initInputBody} from "../../../default/global/js/inputfile";
import {initImageGallery} from "../../../default/global/js/imageGallery";
import {scrollingBanner} from "../../../default/global/js/scrollingBanner";
import {countUp} from "../../../default/global/js/countUp";
import {initInputMaskDate} from "../../../default/global/js/inputMaskDate";
import {initAjaxCollectionFilter} from "../../../default/global/js/ajaxCollectionFilter";
import {initContentTabs} from "../../../default/global/js/contentTabs";
import {initHistorySlider} from "../../../default/global/js/history";
import {initRecaptchaForms} from "../../../default/global/js/recaptchaForm";
import {initHighlightEditors} from "../../../default/global/ts/highlightEditor";
import {maxHeightContent} from "../../../default/global/js/maxHeightContent";

function rearrangeNewsletterSitepart() {
    for (let newsletterForm of document.querySelectorAll('.newsletterFormSitepart')) {
        const newsletterWrapper = newsletterForm.closest('.registrationBanner');
        const newsletterOriginPositionWrapper = document.querySelector('.registrationBanner > div:first-child');

        if (newsletterWrapper) {
            if (window.innerWidth < 1024) {
                newsletterWrapper.append(newsletterForm);
            } else {
                newsletterOriginPositionWrapper.append(newsletterForm);
            }
        }
    }
}


window.addEventListener("load", (event) => {
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");
    const IsTouchDevice = isTouchDevice();
    const stickyHeaderArea = document.querySelector('.headerMain');

    let breakPointSM = 1024;

    if (typeof GLOBALS!== "undefined") {
        breakPointSM = GLOBALS.gridBreakpoints.sm;
    }

    if (mobileMenu && mobileMenuToggle && overlay) {
        const mobileMenuClose = mobileMenu.querySelector(".mobileMenu__close");

        buildMobileMenu(mobileMenu);

        mobileMenuToggle.addEventListener("click", function () {
            showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        })

        mobileMenuClose.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });
    }

    initActionClicks();

    initFormSubmitClicks();

    initFormSubmitChanges();

    trimInputValues();

    focusInputGroups();

    initInputBody();

    if (window.outerWidth < breakPointSM) {
        for (let parent of document.querySelectorAll('.navgroup > ul > li')) {
            getChildrenClassForNestedItems(parent);
        }
    }

    triggerModal();
    excludeModal();
    triggerOpenLinkInModal();
    triggerConfirmModalLink();

    initToggleSlide();

    for (let el of document.querySelectorAll('.js-mainNavigation li')) {
        hoverintent(el);
    }

    setSrcVideos();

    initSlideshows();

    initImageGallery();

    initScrollbars();

    initSlidecontents();

    initCustomSelects();

    for(let headerJumpmark of document.querySelectorAll('.mainnav .jumpmark')) {
        if(!document.querySelector('body').classList.contains('pg_home')) {
            const link = headerJumpmark.getAttribute('href');
            headerJumpmark.setAttribute('href', window.location.origin + link);
        }
    }

    for(let mobileMenuJumpmark of document.querySelectorAll('.mobileMenu .jumpmark')) {
        if(!document.querySelector('body').classList.contains('pg_home')) {
            const link = mobileMenuJumpmark.getAttribute('href');
            mobileMenuJumpmark.setAttribute('href', window.location.origin + link);
        }

        mobileMenuJumpmark.addEventListener('click', () => {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });
    }

    // Tooltip, when necessary
    // import {Tooltip} from "../../../default/global/js/tooltip-custom";

    //var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
    //var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //    return new Tooltip(tooltipTriggerEl);
    //});

    let offsetTopJumpmarks = 0;
    if (stickyHeaderArea) {
        offsetTopJumpmarks = stickyHeaderArea.clientHeight;
    }

    if (typeof GLOBALS!== "undefined") {
        if(GLOBALS.offsetTopJumpmarks){
            offsetTopJumpmarks += GLOBALS.offsetTopJumpmarks;
        }
    }

    initJumpmarks(offsetTopJumpmarks);

    for (let item of document.querySelectorAll(".js-openGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item);
        });
    }

    let offsetTopStickyBox = 30;
    if (stickyHeaderArea) {
        offsetTopStickyBox += stickyHeaderArea.clientHeight;
    }

    for (let pinBox of document.querySelectorAll(".js-stickyBox")) {
        stickyBox(pinBox, {
            offsetTop: offsetTopStickyBox
        });
    }

    lottieLoader();

    addTableWrapper();

    scrollingBanner();

    for (let el of document.querySelectorAll("[data-count-up]")) {
        countUp(el);
    }

    initInputMaskDate();

    initAjaxCollectionFilter();

    initHistorySlider();

    initContentTabs();

    initRecaptchaForms();

    initHighlightEditors();
    // initHighlightPicture();

    maxHeightContent();

    //rearrangeNewsletterSitepart();
});

function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}


window.addEventListener('resize', debounce(() => {
    //rearrangeNewsletterSitepart();
}, 200));